<template>
  <div>
    <template v-if="typePage === 'All'">
      <Order ref="OrderViewComponent"/>
    </template>

    <router-view
        @allOrdersUpdater="allOrdersUpdater"
    ></router-view>
  </div>
</template>

<script>
import Order from "@components/orders/Order.vue";
export default {
  components: {
    Order
  },

  data() {
    return {
      typePage: "",
      openOrder: false,
    };
  },

    methods:{
        allOrdersUpdater(index, id) {
            this.$refs.OrderViewComponent.updateOneOrder(index, id)
        }
    },

  beforeRouteEnter(to, _, next) {
    next((vm) => {
      if (!!to.params.id) {
        vm.typePage = "Detail";
      } else {
        vm.typePage = "All";
      }
    });
  },

  beforeRouteUpdate(to, _, next) {
    if (!!to.params.id === false) {
      this.typePage = "All";
    }
    next();
  },
};
</script>

<style></style>
